import * as actions from './actions';
import referencesReducer, { referencesAdapter, referencesSlice } from './reducer';

const referencesActions = {
  ...referencesSlice.actions,
  ...actions,
};

const referencesSelectors = {
  ...referencesAdapter.getSelectors(),
};

export { referencesActions, referencesReducer, referencesSelectors };
